module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7rTSoP/tc-custom/9781426880704.jpg?1726519033285",
      "alt": "This image is the cover for the book At the Spaniard's Pleasure"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("At the Spaniard's Pleasure\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("He was licensed to thrill!"), _c('br'), _c('br'), _vm._v("When Nick Menendez discovered that beautiful Liza Summers was working for the prime suspect in a diamond robbery case, the Spanish security tycoon took matters into his own hands—and Liza into his custody! He decided the simplest way to uncover the truth "), _c('i', [_vm._v("and")]), _vm._v(" protect her was to take her to his bed—and keep her there until he knew her full involvement…")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jacqueline Baird\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("When Jacqueline Baird is not busy writing she likes to spend her time travelling, reading and playing cards. She enjoys swimming in the sea when the weather allows. With a more sedentary lifestyle, she does visit a gym three times a week and has made the surprising discovery that she gets some of her best ideas while doing mind-numbingly boring exercises on the weight machines and airwalker. Jacqueline lives with her husband Jim in Northumberland.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0